module.exports = __webpack_public_path__ + "static/fonts/fa-regular-400.2d89b49.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/fontawesome-6.6.0/webfonts/fa-regular-400.woff2
// module id = br/3
// module chunks = 2